import React from 'react';
import { Link } from 'react-router-dom';

const footerLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Portfolio', path: '/portfolio' },
  { label: 'Our Design', path: '/our-design' },
  { label: 'Services', path: '/services' },
  { label: 'How We Work', path: '/how-we-work' },
  { label: 'Contact', path: '/contact' },
];

const services = ['Interior Design', 'Turnkey Projects', 'Civil Construction', 'Interior Consultation', 'Modular Kitchens', '3D Design & Visualization'];

export default function Footer() {
  return (
    <footer className="bg-charcoal text-white">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <div className="font-display text-3xl font-semibold">RAGVI</div>
              <div className="font-body text-xs tracking-[0.3em] text-primary-400 uppercase">Design Studio</div>
            </div>
            <p className="font-body text-sm text-gray-400 leading-relaxed mb-6">
              Transforming spaces into luxury living experiences for over 9 years. Your dream space, our expertise.
            </p>
            <div className="flex gap-4">
              {['facebook', 'instagram', 'pinterest', 'youtube'].map(s => (
                <a key={s} href={`https://${s}.com`} target="_blank" rel="noopener noreferrer"
                  className="w-9 h-9 border border-gray-600 flex items-center justify-center text-gray-400 hover:border-primary-500 hover:text-primary-400 transition-colors duration-300">
                  <span className="text-xs uppercase">{s[0]}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-xs tracking-[0.25em] uppercase text-primary-400 mb-5">Quick Links</h4>
            <ul className="space-y-2.5">
              {footerLinks.map(link => (
                <li key={link.path}>
                  <Link to={link.path} className="font-body text-sm text-gray-400 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-body text-xs tracking-[0.25em] uppercase text-primary-400 mb-5">Our Services</h4>
            <ul className="space-y-2.5">
              {services.map(s => (
                <li key={s}>
                  <Link to="/services" className="font-body text-sm text-gray-400 hover:text-white transition-colors duration-200">
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body text-xs tracking-[0.25em] uppercase text-primary-400 mb-5">Contact Us</h4>
            <div className="space-y-4 font-body text-sm text-gray-400">
              <div>
                <p className="text-white text-xs uppercase tracking-widest mb-1">Address</p>
                <p>RZ-3104/35, Tuglakabad Extension<br />New Delhi, Delhi 110019</p>
              </div>
              <div>
                <p className="text-white text-xs uppercase tracking-widest mb-1">Phone</p>
                <a href="tel:+919971397467" className="hover:text-white transition-colors">+91 99713 97467</a>
              </div>
              <div>
                <p className="text-white text-xs uppercase tracking-widest mb-1">Email</p>
                <a href="mailto:ragvidesign@gmail.com" className="hover:text-white transition-colors">ragvidesign@gmail.com</a>
              </div>
              <div>
                <p className="text-white text-xs uppercase tracking-widest mb-1">Hours</p>
                <p>Mon–Sat: 9:00 AM – 7:00 PM</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-gray-500">
            © {new Date().getFullYear()} Ragvi Design Studio. All rights reserved.
          </p>
          <div className="flex gap-6">
            {['Privacy Policy', 'Terms of Service', 'Sitemap'].map(item => (
              <a key={item} href="#" className="font-body text-xs text-gray-500 hover:text-gray-300 transition-colors">
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
